import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { post } from 'src/apis/apiService'
import { LIVE_SESSION_APIS } from 'src/apis/liveSessionApi'

export const JoinButton = ({ hasPlayback, sessionId, secondsTillStart, durationInSeconds }) => {
  const history = useHistory()
  const fifteenMinutes = 900
  const [timer, setTimer] = useState(secondsTillStart - fifteenMinutes)
  const [startTime, setStartTime] = useState(Date.now() + (secondsTillStart - fifteenMinutes) * 1000)
  const [endTime, setEndTime] = useState(Date.now() + (secondsTillStart + durationInSeconds) * 1000)

  useEffect(() => {
    setTimeout(() => {
      if (Date.now() > startTime - 500 && Date.now() < startTime + 500) {
        setTimer(0)
      } else if (Date.now() > endTime) {
        setTimer(0 - (durationInSeconds + fifteenMinutes + 1))
      } else {
        setTimer(timer - 1)
      }
    }, 1000)
  })

  const handleJoin = () => {
    post(
      LIVE_SESSION_APIS.JOIN_SESSION(sessionId),
      (data) => {
        if (data.canJoin) {
          history.push(`/auditorium-hall/${sessionId}`)
        } else {
          toast(`Session has not started. You may join 15 minutes before the start time.`)
        }
      },
      (error) => {
        console.error(error)
        toast(`Session has not started. You may join 15 minutes before the start time.`)
      }
    )
  }
  // LIVE
  if (timer <= 0 && timer + (durationInSeconds + fifteenMinutes) >= 0) {
    return (
      <div className="cardAction align-self-end">
        <button className="join-button" onClick={handleJoin}>
          <span>JOIN NOW</span>
        </button>
      </div>
    )
  }
  // SOON
  if (timer > 0) {
    return (
      <div className="cardAction align-self-end">
        <button className="join-button" onClick={handleJoin}>
          <span>JOIN NOW</span>
        </button>
      </div>
    )
  }
  // ENDED (if playback url exist, allow access)
  return (
    <div className="cardAction align-self-end text-center">
      {hasPlayback ?
        <Link to={`auditorium-hall/${sessionId}?playback`} className="join-button">
          <span>Watch Replay</span>
        </Link>
        :
        <></>
        // <button disabled className="join-button btn-disabled">
        //   <span>Session Ended</span>
        // </button>
      }
    </div>
  )
}